export enum Role {
    ADMIN = 'admin',
    CLIENTE = 'cliente',
    NO_EXISTE = '',
}
